import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderPageSignalDataService {

  public nameUser$ = signal<string | undefined>(undefined);
  public lastAccess$ = signal<string | undefined>(undefined);
  public profileUser$ = signal<string | undefined>(undefined);

  public titleMenu$ = signal<string | undefined>(undefined);
  public titlePage$ = signal<string | undefined>(undefined);
  public subTitlePage$ = signal<string | undefined>(undefined);
  public etapaSubTitlePage$ = signal<string | undefined>(undefined);
  public vbTitlePage$ = signal(false);

  constructor() { }

  public updateNameUser(value: string) {
    const firstName = value.split(' ')[0];
    this.nameUser$.set(firstName);
  }

  public updateLastAccess(value: string) {
    this.lastAccess$.set(value);
  }

  public updateProfileUser(value: string) {
    this.profileUser$.set(value);
  }

  public updateTitleMenu(value: string) {
    this.titleMenu$.set(value);
  }

  public updateTitlePage(value: string) {
    this.titlePage$.set(value);
  }

  public updateEtapaSubTitlePage(value: string) {
    this.etapaSubTitlePage$.set(value);
  }

  public updateSubTitlePage(value: string) {
    this.subTitlePage$.set(value);
  }

  public updateVbTitlePage(value: boolean) {
    this.vbTitlePage$.set(value);
  }
}
